/**
 * The multiplication table
 */
const d = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
];

/**
 * The permutation table
 */
const p = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
];

/**
 * The inverse table
 */
const inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

/**
 * Validates a number string using the Verhoeff algorithm.
 * @param numStr The number string to validate.
 * @returns True if valid, false otherwise.
 */
export const validateVerhoeff = (numStr: any): boolean => {
    // Defensive: Handle null/undefined/non-string
    if (numStr == null || typeof numStr !== 'string') return false;
    if (!/^\d+$/.test(numStr)) return false;

    let c = 0;
    const myArray = numStr.split('').map(Number).reverse();

    for (let i = 0; i < myArray.length; i++) {
        c = d[c][p[i % 8][myArray[i]]];
    }

    return c === 0;
};

/**
 * Generates the Verhoeff checksum digit for a given number string.
 * @param numStr The number string (without the checksum).
 * @returns The checksum digit.
 */
export const generateVerhoeff = (numStr: any): number => {
    // Defensive: Handle null/undefined/non-string
    if (numStr == null || typeof numStr !== 'string') {
        throw new Error('Input must be a non-null string');
    }
    if (!/^\d+$/.test(numStr)) {
        throw new Error('Input must be a numeric string');
    }

    let c = 0;
    const myArray = numStr.split('').map(Number).reverse();

    for (let i = 0; i < myArray.length; i++) {
        c = d[c][p[(i + 1) % 8][myArray[i]]];
    }

    return inv[c];
};
